<template>
    <perfect-scrollbar class="flex-grow-1 d-flex flex-column mt-0" :options="opsScroll">
        <b-card class="flex-grow-1" footer-tag="footer">
            <b-list-group class="mb-4">
                <b-list-group-item>
                    <div class="d-flex justify-content-between">
                        <span>Завершено заказов в этом месяце:</span>
                        <b-spinner v-if="monthStatLoading" class="mr-2" type="border" variant="dark" small></b-spinner>
                        <span v-if="!monthStatLoading">{{monthOrders}}</span>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <div class="d-flex justify-content-between">
                        <span>Заработано в этом месяце:</span>
                        <b-spinner v-if="monthStatLoading" class="mr-2" type="border" variant="dark" small></b-spinner>
                        <span v-if="!monthStatLoading">{{monthSalary}} руб</span>
                    </div>
                </b-list-group-item>
            </b-list-group>
            <b-list-group>
                <b-form-group label-size="sm"  class="mb-0 flex-grow-0 ">
                    <el-date-picker
                            :picker-options="datePickerOptions"
                            value-format="yyyy-MM-dd"
                            format="dd.MM.yyyy"
                            type="date"
                            placeholder="Выбрать день"
                            v-model="actualDate"
                            disabledDate="disabledDate"
                    style="width: 100%">
                    </el-date-picker>
                </b-form-group>
                <h3 class="d-flex justify-content-center mt-2">Статистика за смену</h3>
                <courier-stat ref="courStat" :orders="orders"/>
            </b-list-group>
            <div slot="footer" class="d-flex justify-content-between">
                <span>Зарплата за смену: </span>
                <span>{{allSum}} руб</span>
            </div>
        </b-card>
    </perfect-scrollbar>
</template>

<script>
import commonVar from '@/tempVariables/commonVars'
import courierStat from '@/components/CourierStatDisplay'
import {COURIER_STATS_INDIVIDUAL, COURIER_MONTH_STAT} from '@/constants/graphql'
export default {
  name: 'courierStatistic',
  apollo: {
    orders: {
      query: COURIER_STATS_INDIVIDUAL,
      variables () {
        return {
          day: this.formatedDate()
        }
      },
      update (data) {
        // console.log(data)
        return data.courierStats.nodes
      }
    }
  },
  data: function () {
    return {
      datePickerOptions: {
        disabledDate (date) {
          return date > new Date()
        }
      },
      opsScroll: commonVar.opsPerfectScroll,
      actualDate: new Date(),
      currentDate: new Date(),
      allSum: 0,
      orders: [
      ],
      monthStatLoading: true,
      monthOrders: 0,
      monthSalary: 0
    }
  },
  methods: {
    formatedDate () {
      return this.$moment(this.actualDate).format('YYYY-MM-DD')
    },
    courierMonthStat () {
      this.$apollo.query({
        query: COURIER_MONTH_STAT,
        fetchPolicy: 'network-only',
        variables: {
          mnth: this.$moment(this.currentDate).format('YYYY-MM-DD')
        }
      })
      .then((res) => {
        this.monthOrders = res.data.courierMonthStat.ordcnt
        this.monthSalary = res.data.courierMonthStat.salary
        if (null === this.monthSalary) {
            this.monthSalary = 0
        }
        this.monthStatLoading = false
      })
    }
  },
  updated () {
    this.allSum = this.$refs.courStat.deliveryPriceStats()
  },
  watch: {
    actualDate () {
      this.$apollo.queries.orders.refetch()
    }
  },
  computed: {
  },
  components: {
    courierStat
  },
  created () {
    this.courierMonthStat()
  }
}
</script>

<style scoped>
    .salary-color{
        background-color: #f2f5f8;
    }
</style>



// WEBPACK FOOTER //
// src/components/CourierStatistic.vue